// extracted by mini-css-extract-plugin
export default {"alert":"alert-styles_component_alert__-b+BW","sizeIcon":"alert-styles_component_sizeIcon__Xp-Ky"};